import SDIcon from './SDIcon'

const IconCarbonUser = (props) => (
  <SDIcon title='User' {...props}>
    <path d='M16,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,16,2Z' />
    <path d='M26,30H24V25a5,5,0,0,0-5-5H13a5,5,0,0,0-5,5v5H6V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z' />
  </SDIcon>
)

export default IconCarbonUser
